
































import { TaskUserCommitsItem } from '@/api';
import Vue, { PropType } from 'vue';

export default Vue.extend({
    props: {
        spdApi: { type: Object },
        commit: { type: Object as PropType<TaskUserCommitsItem> },
        spdParams: { type: Object },
    },
    data() {
        return {
            wanderSpeedIdx: 2,
            wanderSpeedConfig: [0.25, 0.5, 1, 2, 4, 8],
        };
    },
    methods: {
        wanderSpeedFormatter(val) {
            return `${this.wanderSpeedConfig[val]}X`;
        },
        sliderChange() {
            try {
                this.spdParams.wd_moveSpeed = this.wanderSpeedConfig[this.wanderSpeedIdx] * 10; // 设置漫游速度
                this.spdParams.wd_moveVerticalSpeed = this.wanderSpeedConfig[this.wanderSpeedIdx] * 10;
            } catch (error) {
                console.warn('not find PARAMS');
            }

            // console.log(this.wanderSpeedConfig[this.wanderSpeedIdx]);
            // // 设置漫游速度
            // try {
            //     this.spdApi.setWanderMoveSpeed(this.wanderSpeedConfig[this.wanderSpeedIdx]);
            // } catch (error) {
            //     console.error('not found setWanderMoveSpeed');
            // }
        },
        // 回到起始点
        returnInitPosition() {
            this.spdApi.setWanderPos(null, true);
        },
    },
});
